import { FC } from 'react'

import { pad2, useCountdown } from './useCountdown'

type Props = {
  expiresAt: string | null
  variant?: 'dark' | 'light'
}

const Digit: FC<{ value: string, label: string, variant: 'dark' | 'light' }> = ({ value, label, variant }) => (
  <div className="flex flex-col items-center">
    <div
      key={value}
      className={`animate-tick-flip font-aeonik text-[34px] md:text-[44px] leading-none font-medium tabular-nums tracking-tight ${variant === 'dark' ? 'text-white' : 'text-black'}`}
    >
      {value}
    </div>
    <div className={`mt-1 text-[10px] uppercase tracking-[0.18em] ${variant === 'dark' ? 'text-white/50' : 'text-black/50'}`}>{label}</div>
  </div>
)

// compte à rebours « ce site vous est réservé » : grands chiffres, sobre, noir et blanc. Délai
// passé : rien, le site est toujours là tant que la suppression des brouillons est désactivée
// (spec §20)
const SiteCountdown: FC<Props> = ({ expiresAt, variant = 'dark' }) => {
  const countdown = useCountdown(expiresAt)
  if (!countdown || countdown.expired) return null

  const colon = <div className={`pb-5 font-aeonik text-[30px] md:text-[38px] leading-none ${variant === 'dark' ? 'text-white/40' : 'text-black/30'}`}>:</div>
  const urgent = countdown.totalSeconds < 3600
  // au-delà de 48 h (offre à 7 jours) : jours, heures, minutes ; sinon heures, minutes, secondes
  const inDays = countdown.hours >= 48

  return (
    <div
      className={`rounded-2xl border px-5 py-4 ${variant === 'dark' ? 'border-white/15 bg-white/5' : 'border-black/10 bg-black/[0.03]'} ${urgent ? 'animate-pulse-ring' : ''}`}
    >
      <div className={`text-[11px] uppercase tracking-[0.2em] mb-3 ${variant === 'dark' ? 'text-white/60' : 'text-black/50'}`}>
        Ce site vous est réservé encore
      </div>
      <div className="flex items-end justify-center gap-3">
        {inDays ? (
          <>
            <Digit value={String(countdown.days)} label="jours" variant={variant} />
            {colon}
            <Digit value={pad2(countdown.hours % 24)} label="heures" variant={variant} />
            {colon}
            <Digit value={pad2(countdown.minutes)} label="minutes" variant={variant} />
          </>
        ) : (
          <>
            <Digit value={pad2(countdown.hours)} label="heures" variant={variant} />
            {colon}
            <Digit value={pad2(countdown.minutes)} label="minutes" variant={variant} />
            {colon}
            <Digit value={pad2(countdown.seconds)} label="secondes" variant={variant} />
          </>
        )}
      </div>
      <div className={`mt-3 text-xs ${variant === 'dark' ? 'text-white/60' : 'text-black/60'}`}>
        Passé ce délai, ce site n’est plus réservé : il peut être retiré de la ligne.
      </div>
    </div>
  )
}

export default SiteCountdown
